// Base
import { useRouter } from 'next/router'
import { useEffect } from 'react'

// Redux
import { useAppDispatch, useAppSelector } from '@redux/hooks'
import { showScreenBlock } from '@redux/slices/utilitiesSlice'

// Components
import Box from '@components/helpers/box/Box'

// Styles
import styles from './ScreenBlock.module.sass'

const ScreenBlock = () => {
  const router = useRouter()
  const dispatch = useAppDispatch()

  const { screenBlock } = useAppSelector((state) => state.utilities)

  useEffect(() => {
    if (screenBlock) {
      dispatch(showScreenBlock(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.route])

  if (!screenBlock) {
    return null
  }

  return (
    <Box backgroundColor="white" opacity={30} className={styles.screen}></Box>
  )
}

export default ScreenBlock
